

export const SliderData = [
    {
        image : 'https://onemg.gumlet.io/22faa6c5-87af-4ee2-be51-4923024b8d9a_1666337787.jpg?w=899&h=200&format=auto',
    },

  {
    image : 'https://onemg.gumlet.io/ea75668c-b095-427a-95d7-e10d8d01d348_1664863610.jpg?w=899&h=200&format=auto',

  },
  {
    image : 'https://onemg.gumlet.io/a_ignore,w_899,h_200,c_fit,q_auto,f_auto/86b117e9-a698-439d-9c65-559c848ce2c6.png'
  },
  {
    image : 'https://onemg.gumlet.io/a_ignore,w_899,h_200,c_fit,q_auto,f_auto/c5c79b59-a029-48a4-b1ca-5a3167c5619e.png',
  },
  {
    image : 'https://onemg.gumlet.io/a_ignore,w_899,h_200,c_fit,q_auto,f_auto/826647b4-eed5-4931-a433-f7b325e8ccc4.png',
  },

  {
    image : 'https://onemg.gumlet.io/7813da63-d0a5-4461-a897-274de753f95e_1663825942.png?w=899&h=200&format=auto',
  },
  {
    image : 'https://onemg.gumlet.io/2ccf07c4-5708-4732-84a0-54fe642f2442_1667466063.jpg?w=899&h=200&format=auto',
  },
  {
    image : 'https://onemg.gumlet.io/a_ignore,w_899,h_200,c_fit,q_auto,f_auto/8e66b76c-9fd0-4215-88c4-61f1800e3847.png',
  },
  {
    image : 'https://onemg.gumlet.io/409bc9dd-ee9a-40bf-ad53-75627d19db31_1660826530.jpg?w=899&h=200&format=auto'
  }

]
